// This file contains provides a temporary implementation of a touch and mouse compatible API. When the W3C Pointer
// API is more broadly supported this should be removed and all events reworked to utilize it instead.

let lastTouchStart;

/**
 * Converts a mouse or touch event to a normal form. NOTE: Not multi-touch enabled.
 * @param e
 * @returns {{clientX: *, clientY: *, pageX: *, pageY: *}}
 */
export function pointerEvent (e) {
  let proxy;
  if (e.type === 'touchend') {
    proxy = lastTouchStart;
  } else {
    proxy = {
      // Being conservative about the events we forward on.
      view: e.view,
      clientX: getFirstOrDefault(e, 'clientX'),
      clientY: getFirstOrDefault(e, 'clientY'),
      pageX: getFirstOrDefault(e, 'pageX'),
      pageY: getFirstOrDefault(e, 'pageY')
    };
    lastTouchStart = proxy;
  }

  proxy.preventDefault = () => e.preventDefault();
  return proxy;
}

function getFirstOrDefault (e, key) {
  return e.touches ? e.touches[0][key] : e[key];
}

const touchMap = {
  'mousedown': 'touchstart',
  'mouseup': 'touchend',
  'mousemove': 'touchmove'
};

/**
 * Adds both mouse and touch event listeners for various mouse handlers. If no touch equiv exists only the mouse event
 * is added
 * @param domNode
 * @param mouseEvent
 * @param delegate
 */
export function addPointerListener (domNode, mouseEvent, delegate) {
  domNode.addEventListener(mouseEvent, delegate);
  const touchEvent = touchMap[mouseEvent];
  if (touchEvent) {
    delegate = wrappers.create(delegate);
    domNode.addEventListener(touchEvent, delegate, {passive: false});
  }
}

export function removePointerListener (domNode, mouseEvent, delegate) {
  domNode.removeEventListener(mouseEvent, delegate);
  const touchEvent = touchMap[mouseEvent];
  if (touchEvent) {
    delegate = wrappers.destroy(delegate);
    domNode.removeEventListener(touchEvent, delegate);
  }
}

const wrappers = {
  list: [],
  create: (delegate) => {
    function wrapper (e) {
      return delegate(pointerEvent(e));
    }

    wrappers.list.push({wrapper, delegate});
    return wrapper;
  },
  destroy: (delegate) => {
    const list = wrappers.list;
    const node = list.find(w => w.delegate === delegate);
    if (node) {
      list.splice(list.indexOf(node), 1);
      return node.wrapper;
    }
  }
};



// WEBPACK FOOTER //
// ./src/uScope/js/lib/utility/pointerApi.js